import { connect } from 'react-redux';
import UnconnectedSearchError from './UnconnectedSearchError';
import { fetchSearchResults } from 'store/search/searchActions';
import { getHasError } from 'store/search/searchSelectors';

const SearchError = connect(
  (state) => ({ hasError: getHasError(state) }),
  (dispatch) => ({
    onRefreshClick: () => dispatch(fetchSearchResults()),
  }),
)(UnconnectedSearchError);

SearchError.displayName = 'SearchError';

export default SearchError;
